import React from 'react'

const TextElement = (props) => {


    return (<div>Text</div>)
}

export default TextElement;